import { RemoteProfileUpdate } from 'data/usecases';
import { makeApiUrlProfile } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteProfileUpdate = (): RemoteProfileUpdate => {
  return new RemoteProfileUpdate(makeApiUrlProfile(), makeAxiosHttpClient());
};
